// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202611041203/js/" + chunkId + "." + {"44":"fc146ff3","225":"b3e2a727","481":"7868db84","486":"cdffa6e6","770":"399a24dd"}[chunkId] + ".0.34900643577106183.chunk.js";
};